export default __webpack_public_path__ + "static/media/2.501e4de0.webp";